module.exports = __webpack_public_path__ + "img/80.9560b5d5.jpg";